module.exports = __webpack_public_path__ + "static/media/cp1in.3f482ab6.png";